module.exports = {
    "oh_url": "https://ophub.litedev.com",
    "pro_url": "https://ophub.litedev.com/pro2",
    "com_url": "https://chub.litedev.com",
    "family_url":"https://fhub.litedev.com/pro",
    "socket_url": "https://socketdev.litedev.com",
    "chs_url": "https://chs.litedev.com",
    "lab_url": "https://lab.litedev.com",
    "nurse_url": "https://nurse.litedev.com",
    "auth_url":"https://auth.litedev.com",
    "version": "0.0.1"
    /* "oh_url": "http://localhost:4003",
    "pro_url": "http://localhost:4003/pro2",
    "com_url": "http://localhost:7001" */
}